// src/pages/company/SupportUs.js
import React from 'react';
const SupportUs = () => <div>Support Us Page</div>;
export default SupportUs;
